import { useEffect, useState } from "react";
import { Radio, CheckCircle2 } from "lucide-react";
import { Card } from "./ui/card";

/** Chi sta provando il gestionale proprio ora: si aggiorna da solo ogni 15 secondi. */
export const ProveDalVivo = ({ client }) => {
  const [live, setLive] = useState(null);

  useEffect(() => {
    let vivo = true;
    const tira = async () => {
      try {
        const r = await client.get("/admin/quiz-live");
        if (vivo) setLive(r.data);
      } catch {
        /* la Console resta aperta anche se un giro va a vuoto */
      }
    };
    tira();
    const i = setInterval(tira, 15000);
    return () => {
      vivo = false;
      clearInterval(i);
    };
  }, [client]);

  if (!live) return null;
  const righe = live.sessioni || [];

  return (
    <Card className="border-slate-800 bg-[#111827] p-5 text-slate-100" data-testid="console-prove-live">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="flex items-center gap-2 text-[10px] font-bold uppercase tracking-[0.24em] text-slate-400">
          <Radio className={`h-4 w-4 ${live.adesso ? "animate-pulse text-emerald-400" : "text-slate-600"}`} />
          Prove dal vivo
        </p>
        <span className="text-xs text-slate-500">ultimi {live.minuti} minuti</span>
      </div>

      <p className="mt-2 text-2xl font-bold" data-testid="prove-live-count">
        {live.adesso === 0
          ? "Nessuno sta provando adesso"
          : `${live.adesso} ${live.adesso === 1 ? "persona sta provando" : "persone stanno provando"} adesso`}
      </p>
      {live.finite > 0 && (
        <p className="mt-1 flex items-center gap-1.5 text-sm text-emerald-400">
          <CheckCircle2 className="h-4 w-4" /> {live.finite} {live.finite === 1 ? "ha" : "hanno"} finito tutta la prova
        </p>
      )}

      {righe.length > 0 && (
        <ul className="mt-4 space-y-2">
          {righe.map((s, i) => (
            <li key={i} className="flex flex-wrap items-center gap-2 rounded-lg bg-slate-900/70 px-3 py-2 text-sm"
                data-testid={`prova-live-${i}`}>
              <span className={`h-2 w-2 shrink-0 rounded-full ${s.done ? "bg-emerald-400" : "bg-amber-400"}`} />
              <span className="min-w-0 flex-1 truncate">
                {s.done ? "Prova completata" : `Domanda ${s.step} · ${s.label}`}
              </span>
              <span className="shrink-0 text-xs text-slate-500">
                {s.device} · {s.country} · {s.lang} · da {s.da_minuti} min
                {!s.done && s.fermo_da >= 3 && ` · fermo da ${s.fermo_da} min`}
              </span>
            </li>
          ))}
        </ul>
      )}
    </Card>
  );
};
